import fn_core from '../../frontend/src/fn_core';

class fn extends fn_core {

    /**
     * @param {event} e: a 'Szerződő is biztosított' kapcsoló által kiváltott esemény
     * @returns {void}: a 'Szerződő is biztosított' kapcsoló alkalmazása
     */
    apply_contractor_checkbox(e) {
        var row = $(e.currentTarget);
        if (parseInt(row.rVal())) {
            $('#biztositott_0_biztositottFej').html('Szerződő');
            $('#biztositott_0_szn').datepicker('option', 'maxDate', '-18y');
            $('#biztositott_1_biztositottFej').html('1. biztosított');
            $('#biztositott_2_biztositottFej').html('2. biztosított');
            $('#biztositott_3_biztositottFej').html('3. biztosított');
            $('#biztositott_4_biztositottFej').html('4. biztosított');
        } else {
            $('#biztositott_0_biztositottFej').html('1. biztosított');
            $('#biztositott_0_szn').datepicker('option', 'maxDate', '0d');
            $('#biztositott_1_biztositottFej').html('2. biztosított');
            $('#biztositott_2_biztositottFej').html('3. biztosított');
            $('#biztositott_3_biztositottFej').html('4. biztosított');
            $('#biztositott_4_biztositottFej').html('5. biztosított');
        }
    }

    /** @returns {void}: kosár alkalmazása */
    basket_change() {
        var val = [];
        val[0] = 'baleset';

        var html = engine.ajaxFunc('basket', val);
        if ($('#cartBox').length) {
            $('#cartBox').replaceWith(html);
        } else {
            $('#call-back-placeholder').after(html);
        }
        console.log('basket_change');
    }

    /**
     * @param {element}: bemenő HTML táblázat
     * @returns {void}: eredményoldal inicializálása
     */
    result_init(table) {
        table.on('click', '.more-details .ui-btn', function (e) {
            $(this).closest('tr').toggleClass('show-details');
            e.stopPropagation();
        }).on('click', '.icon-rate', function (e) {
            engine.popMsg($('#htemp .star.tmp').html());
            e.stopPropagation();
        }).tooltip({
            items: "div.term_description",
            track: true,
            content: function () {
                return $(this).data('title');
            }
        });
        var h = $('#result-head');
        var d = engine.result.settings.init;

        $('#bottom_area .bdb').text(d.bizt_db);
        $('#bottom_area .tdb').text(d.term_db_f);

        if (d.termid) {
            table.find('tr[data-id=' + d.termid + ']').trigger('click');
        }
    }

    /** @returns {void}: eredményoldal frissítése */
    result_pollEnd() {
        $('tr.disabled').hide();
        var insNames = [];
        $('.hasprice .name .wrap .name').each(function (i, tr) {
            var insurer = $(tr).html();
            if (insNames.indexOf(insurer) == -1) {
                insNames.push(insurer);
            }
        });
        if($('.hasprice').length){
            $('.empty').hide();
        }else{
            $('.empty td').text('A beadott adatok alapján nincs a kínálatunkban megfelelő biztosítás.');
            $('.empty').show();
        }
        $('#bottom_area .bdb').text(insNames.length);
        $('#bottom_area .tdb').text($('.hasprice').length);
        engine.result.pollEndSort(engine.result.table.find('th.price'));
    }

    /**
     * @param {element}: bemenő sor a termékek táblázatában
     * @returns {void}: bevásárlókosár frissítése
     */
    cart_set(tr) {
        var h = $('#result-head');
        var ch = h.find('.ui-block-d,.ui-block-e');
        ch.fadeOut(300, 'linear', function () {
            h.find('div.name').text(tr.find('div.name').text());
            h.find('div.type').text(tr.find('div.type').text());
            h.find('div.price').text(tr.find('div.price').text());
            h.addClass('active');
            ch.fadeIn(300, 'linear');
        });
        engine.result.table.find('tr').removeClass('active');
        tr.addClass('active');
        $('#chTermId').val(tr.data('id'));
    }

    /**
     * @param {event} e: a kedvezményezettek számának megváltoztatása által kiváltott esemény
     * @returns {void}: kiszámolja a kedvezményezett arányokat a kedvezményezettek száma alapján
     */
    set_beneficiary_ratios(e) {
        var row = $(e.currentTarget);
        var number = parseInt(row.rVal());
        var tid = e.target.id;
        var pId = tid.replace('_szama', '');
        if (number < 1) { return; }
        var ratio = Math.floor(100 / number);
        var remainder = 100;
        for (var i = 0; i < number; ++i) {
            remainder -= ratio;
            if (i == 0) { continue; }
            $('#' + pId + '_' + i + '_arany').val(ratio);
        }
        $('#' + pId + '_0_arany').val(ratio + remainder);
    }

    /**
     * @param {event} e: a kedvezményezettek arányának megváltoztatása által kiváltott esemény
     * @returns {void}: kiszámolja az új kedvezményezett arányokat a megváltoztatott arány alapján
     */
    sync_beneficiary_ratios(e) {
        var row = $(e.currentTarget);
        var new_ratio = Math.min(Math.max(parseInt(row.rVal()), 0), 100);
        $('#' + e.target.id).val(new_ratio);
        var remainder = 100-new_ratio;
        var tid = e.target.id;
        var beneficiaryBaseId = tid.replace(/_kedvezmenyezettek_[0-9]+_arany/i, '');
        var currentBeneficiary_text = tid.replace(/.*_kedvezmenyezettei_[0-9]+_kedvezmenyezettek_/i, '');
        var currentBeneficiary = parseInt(currentBeneficiary_text.replace('_arany', ''));
        var number = parseInt($('#' + beneficiaryBaseId+'_kedvezmenyezettek_szama').val());
        if (number < 2) { return; }
        var targetBeneficiaryId = '';
        var currentRatio = 0;
        for (var i = 0; i < number; ++i) {
            if(i==currentBeneficiary){ continue; }
            targetBeneficiaryId = beneficiaryBaseId+'_kedvezmenyezettek_'+i+'_arany';
            currentRatio = parseInt($('#' + targetBeneficiaryId).val());
            remainder -= currentRatio;
        }
        remainder += currentRatio;
        remainder = Math.min(Math.max(remainder, 0), 100);
        $('#' + targetBeneficiaryId).val(remainder);
    }
}

export default fn